// extracted by mini-css-extract-plugin
export default {"tooltip":"HQ-z","arrow":"IQ-z"};